export const minSnapshotDiscrepancyUSD = 10;
